module.exports = __webpack_public_path__ + "static/media/python.3640846b.png";